import React, {Component} from "react";
import {IconButton, Stack, Tooltip} from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import {morphleBaseTheme1} from "../themes";
import {addScreenshotToReport} from "../utils/screenshot_utils";
import {connect} from "react-redux";
import {componentIds} from "../../../utils/const";
import {isNull, notNull} from "../../../utils/utils";
import {Loading} from "../components/components";
import {message} from "antd";
import {CASE_STATUS} from "../../../const/cases_const";
import {get} from "../../../helper/request";
import {store} from "../../../helper/store";
import {fetchCase} from "../../../redux_actions/case.action";

class CaseImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currCase: {},
			isFetchingCase: false,
        }
		this.lockCapReport = this.props.abstract_configs['lockCapReport'];
    }

	componentDidMount() {
		notNull(this.props.slide.case) && this.getCase();
	}

	getCase = () => {
		this.setState({
			isFetchingCase: true,
		});
		let url = `/api/case/` + this.props.slide.case + `/`;
		get(url, true)
			.then(data => {
				this.setState({
					currCase: data,
					isFetchingCase: false,
				});
			})
			.catch(err => {
				if (err?.response?.status === 403) {
					// message.error("You don't have ACL permission to view this case")
				} else {
					message.error("Cases could not be retrieved. Contact Admin.");
				}
				this.setState({
					currCase: [],
					isFetchingCase: false,
				});
				console.log(err);
			});
	}

	render() {
	    if (!this.props.slide)
		    return <Loading/>;

	    let componentDisabled = isNull(this.props.slide.case);
		let caseStatus = this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED;
	    let {x, y, z, r} = this.props;

	    return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
		    <Tooltip title={componentDisabled ? "Slide has no Case Assigned" : caseStatus ? "Report Generated" :
				"Add to Case"} placement={"bottom"}>
			    <IconButton size="small" disabled={componentDisabled || caseStatus}
			                onClick={() => addScreenshotToReport(componentIds.slideMaps, this.props.slide,
				                this.props.activeMapId, this.props.extension, this.props.displaySetting,
								JSON.stringify({
									mapState: {x, y, z, r},
								}), "")}>
				    <AddPhotoAlternateIcon sx={{
						color: morphleBaseTheme1.palette.headBarIcon.primary,
						opacity: componentDisabled ? 0.6 : caseStatus ? 0.8 : 1
					}}/>
			    </IconButton>
		    </Tooltip>
	    </Stack>
    }
}


const mapStateToProps = (state) => {
	let {abstract_configs} = state.morpheusSettingReducer;
	let {activeMapId} = state.gammaStateReducer;
	let {slide, x, y, z, r, displaySetting} = state.mapsStateReducer[activeMapId];
	let {extension} = state.screenshotStateReducer;
	let caseState = state.caseReducer;
	return {activeMapId, x, y, z, r, slide, extension, displaySetting, caseState, abstract_configs};
}
export default connect(mapStateToProps)(CaseImage)
